export const environment = {
  production: false,
  baseApi: 'https://dev-api.wallofshame.wtf/dev',
  // baseApi: 'http://192.168.150.115:8473/local',
  s3Api: 'https://wall-of-shame-api-dev-tiles-metadata.s3.amazonaws.com',
  contractAddress: '0x0a10285203bc7eA7EF3bfeb72FCdeF63747e1140',
  metamaskChannel: {
    chainId: '4',
    rpcUrl: 'https://rinkeby.infura.io/v3/',
    chainName: 'Rinkeby Test Network',
    explorerUrl: 'https://rinkeby.etherscan.io',
  },
};
